import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { LogoCardContainerComponent } from '../shared/components/logo-card-container/logo-card-container.component';
import { UserFacadeService } from '../services/user-facade.service';
import { catchError, EMPTY, throwError } from 'rxjs';

@Component({
  selector: 'app-login',
  host: { class: 'vanhu-content-page' },
  imports: [
    MatCardModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    LogoCardContainerComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private router = inject(Router);
  private userFacadeService = inject(UserFacadeService);

  error: 'none' | 'interaction_in_progress' | 'unknown' = 'none';

  logIn() {
    console.debug('[LoginComponent] logIn()');

    this.error = 'none';
    this.userFacadeService
      .logInOrCreateUser('login')
      .pipe(
        catchError(error => {
          if (error.errorCode === 'interaction_in_progress') {
            console.warn('[LoginComponent] logIn(): interaction_in_progress error occurred.');
            this.error = 'interaction_in_progress';
            return EMPTY;
          } else {
            this.error = 'unknown';
            return throwError(() => error);
          }
        }),
      )
      .subscribe();
  }

  signUp() {
    console.debug('[LoginComponent] signUp()');

    return this.router.navigate(['/sign-up']);
  }

  forceRestartLogin() {
    console.warn('[LoginComponent] forceRestartLogin()');

    // Clear MSAL interaction flag for popups
    sessionStorage.removeItem('msal.interaction.status');
    this.logIn();
  }
}
